export default "__VITE_ASSET__e997bc0b__"